var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBookings = function SvgBookings(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8.25C1.5 6.17893 3.17893 4.5 5.25 4.5H30.75C32.8211 4.5 34.5 6.17893 34.5 8.25V30.75C34.5 32.8211 32.8211 34.5 30.75 34.5H5.25C3.17893 34.5 1.5 32.8211 1.5 30.75V8.25ZM5.25 7.5C4.83579 7.5 4.5 7.83579 4.5 8.25V30.75C4.5 31.1642 4.83579 31.5 5.25 31.5H30.75C31.1642 31.5 31.5 31.1642 31.5 30.75V8.25C31.5 7.83579 31.1642 7.5 30.75 7.5H5.25Z",
    fill: "#7EAAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 1.5C12.0784 1.5 12.75 2.17157 12.75 3V9C12.75 9.82843 12.0784 10.5 11.25 10.5C10.4216 10.5 9.75 9.82843 9.75 9V3C9.75 2.17157 10.4216 1.5 11.25 1.5Z",
    fill: "#7EAAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.75 1.5C25.5784 1.5 26.25 2.17157 26.25 3V9C26.25 9.82843 25.5784 10.5 24.75 10.5C23.9216 10.5 23.25 9.82843 23.25 9V3C23.25 2.17157 23.9216 1.5 24.75 1.5Z",
    fill: "#7EAAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19.5C19.2426 19.5 20.25 18.4926 20.25 17.25C20.25 16.0074 19.2426 15 18 15C16.7574 15 15.75 16.0074 15.75 17.25C15.75 18.4926 16.7574 19.5 18 19.5Z",
    fill: "#0258FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 19.5C27.4926 19.5 28.5 18.4926 28.5 17.25C28.5 16.0074 27.4926 15 26.25 15C25.0074 15 24 16.0074 24 17.25C24 18.4926 25.0074 19.5 26.25 19.5Z",
    fill: "#0258FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 27.75C10.9926 27.75 12 26.7426 12 25.5C12 24.2574 10.9926 23.25 9.75 23.25C8.50736 23.25 7.5 24.2574 7.5 25.5C7.5 26.7426 8.50736 27.75 9.75 27.75Z",
    fill: "#0258FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 27.75C19.2426 27.75 20.25 26.7426 20.25 25.5C20.25 24.2574 19.2426 23.25 18 23.25C16.7574 23.25 15.75 24.2574 15.75 25.5C15.75 26.7426 16.7574 27.75 18 27.75Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookings.fa0ea02b.svg";
export { ForwardRef as ReactComponent };